import { dampNumber } from '../utils/numbers.js'

export function updateSmoothedNumericValues({
  deltaTime,
  effectParams,
  effectRuntime,
  cameraParams,
  cameraRuntime,
  fishEyeParams,
  fishEyeRuntime,
  controls,
  effectUniforms,
  syncFishEyeParams
}) {
  effectRuntime.intensity = dampNumber(effectRuntime.intensity, effectParams.intensity, deltaTime)
  effectRuntime.speed = dampNumber(effectRuntime.speed, effectParams.speed, deltaTime)
  effectRuntime.replayDuration = dampNumber(effectRuntime.replayDuration, effectParams.replayDuration, deltaTime)
  cameraRuntime.autoRotateSpeed = dampNumber(cameraRuntime.autoRotateSpeed, cameraParams.autoRotateSpeed, deltaTime)
  fishEyeRuntime.strength = dampNumber(fishEyeRuntime.strength, fishEyeParams.strength, deltaTime)
  fishEyeRuntime.radius = dampNumber(fishEyeRuntime.radius, fishEyeParams.radius, deltaTime)
  fishEyeRuntime.distortionPower = dampNumber(fishEyeRuntime.distortionPower, fishEyeParams.distortionPower, deltaTime)
  fishEyeRuntime.blend = dampNumber(fishEyeRuntime.blend, fishEyeParams.blend, deltaTime)
  fishEyeRuntime.chromaticAberration = dampNumber(
    fishEyeRuntime.chromaticAberration,
    fishEyeParams.chromaticAberration,
    deltaTime
  )
  fishEyeRuntime.zoom = dampNumber(fishEyeRuntime.zoom, fishEyeParams.zoom, deltaTime)
  fishEyeRuntime.centerX = dampNumber(fishEyeRuntime.centerX, fishEyeParams.centerX, deltaTime)
  fishEyeRuntime.centerY = dampNumber(fishEyeRuntime.centerY, fishEyeParams.centerY, deltaTime)
  fishEyeRuntime.edgeFeather = dampNumber(fishEyeRuntime.edgeFeather, fishEyeParams.edgeFeather, deltaTime)
  fishEyeRuntime.edgeColor = fishEyeParams.edgeColor

  controls.autoRotateSpeed = cameraRuntime.autoRotateSpeed
  effectUniforms.effectIntensity.value = effectRuntime.intensity
  syncFishEyeParams(fishEyeRuntime)
}
